<template>
  <b-container fluid>
    <div>
    <h1>Concesionarios</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar concesionario"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getConcesionarios"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
    <template v-slot:cell(preferential)="row">
      <template v-if="row.item.preferential == undefined">
      </template>
      <template v-else>
        <div :class="statusDictionary[row.item.preferential].class">{{ statusDictionary[row.item.preferential].label }}</div>
      </template>
    </template>
      <template v-slot:cell(acciones)="row" v-if="this.$store.state.user.role != 'AUTORIDADES - STCH'">
        <router-link size="sm" :to="{name:'updateConcesionarios', params: row.item}" class="mr-1"><b-button class="btn-sm" variant="outline-warning">Editar</b-button></router-link>
        <!--<b-button class="btn-sm" v-if="row.item.active" variant="outline-danger" v-b-modal.modal-prevent-closing @click="getIdRow({id:row.item.id})">Deshabilitar</b-button>-->
        <b-button class="btn-sm" v-if="row.item.active" variant="outline-danger" v-b-modal.modal-prevent-closing @click="validateCheckIn(row.item)">Deshabilitar</b-button>
        <!--<b-button class="btn-sm" v-if="!row.item.active" variant="outline-success" @click="activateFranchise({id:row.item.id})">Habilitar</b-button>-->
        <b-button class="btn-sm" v-if="!row.item.active" variant="outline-success" @click="showConfirmEnable(row.item)">Habilitar</b-button>
        <!--<router-link size="sm" class="ml-1" :to="{name:'historialPagos', params: row.item}"><b-button class="btn-sm" variant="outline-dark">pagos</b-button></router-link>-->
      </template>
      <template v-slot:cell(motivos)="row">
        <b-button class="btn-sm ml-1" v-if="!row.item.active" variant="outline-info" v-b-modal.modal-prevent-closing-motivos @click="getIdMotivo({id:row.item.id})">Motivos de Baja</b-button>
      </template>
      <template v-slot:cell(active)='row'>
        <p>{{row.item.active === 1 ? 'Habilitado' : 'Deshabilitado'}}</p>
      </template>
      <template v-slot:cell(phoneNumber)='row'>
        <p>{{row.item.phoneNumber.replace('+52','')}}</p>
      </template>
    </b-table>

    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
  <!--Modal para ingresar motivos de baja-->
  <div>
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      :title="'¿Estás seguro(a) que deseas deshabilitar el concesionario ' + enableDisableFranchiseName + '?'"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
      cancel-title='Cancelar'
      ok-title="Aceptar"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          :state="reasonState"
          label="Motivo de baja"
          label-for="reason-input"
          invalid-feedback="El motivo es requerido"
        >
          <b-form-input
            id="reason-input"
            placeholder="Motivo de baja"
            v-model="reason"
            :state="reasonState"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
        label="Evidencia (Adjuntar archivo .jpg, .png, .pdf)"
        :state="fileState"
        invalid-feedback="Adjuntar motivo es requerido"
        >
          <b-form-file
          v-model="selectedFile"
          :state="fileState"
          placeholder="Evidencia"
          browse-text="Adjuntar"
          drop-placeholder="Drop file here..."
          @change="onFileSelected"
          required
          accept="application/pdf,image/x-png,image/gif,image/jpeg"
          ></b-form-file>
        </b-form-group>
      </form>
      <!--<b-button class="mt-3" block @click="$bvModal.hide('bv-modal-example')">Close Me</b-button>-->
    </b-modal>
  </div>
  <!--Modal para visualizar motivos de baja-->
  <div>
    <b-modal
      ok-only
      id="modal-prevent-closing-motivos"
      ref="modal"
      title="Motivos de Baja"
      @show="resetModal"
      @hidden="resetModal"
    >
    <b-table
      show-empty
      stacked="md"
      :items="getBansByConcesionarioId"
      :fields="fieldsMotivos"
      :current-page="currentPageMotivos"
      :per-page="perPageMotivos"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
    >
    <div class="text-center" v-if="$apollo.queries.getBansByConcesionarioId.loading">
    <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
  </div>
    <template v-slot:cell(acciones)="row">
      <b-button class="btn-sm" v-if="!row.item.active" variant="outline-success" @click="viewEvidence({id:row.item.fileUrl})">Evidencia</b-button>
    </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPageMotivos"
          :total-rows="totalRowsMotivos"
          :per-page="perPageMotivos"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    </b-modal>
  </div>
  <div class="text-center" v-if="$apollo.queries.getConcesionarios.loading">
    <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
  </div>
  </b-container>
</template>
<script>
import gql from 'graphql-tag'
import { uploadFileS3 } from '../../../s3/s3Up'
// import { encrypt } from '@/config/headers'
import { Modal } from 'ant-design-vue'
import headers from '@/config/headers.js'
const GET_ACTIVE_CHECKIN_BY_CONCESIONARIOID = gql`
  query getActiveTaxiCheckInByConcesionarioId($concesionarioId: Int){
    getActiveTaxiCheckInByConcesionarioId(concesionarioId: $concesionarioId){
      id
      date
      checkInTime
      checkOutTime
      status
    }
  }
`
export default {
  name: 'Franchises',
  data() {
    return {
      reason: '',
      reasonState: null,
      selectedFile: null,
      fileState: null,
      fileUploaded: null,
      getConcesionarios: [{}],
      objectFile: [],
      fileExtension: null,
      enableDisableFranchiseName: null,
      fields: [
        // { key: 'id', label: 'Id ', sortable: true, sortDirection: 'desc' },
        { key: 'name', label: 'Concesionario' },
        { key: 'rfc', label: 'RFC' },
        { key: 'email', label: 'Correo electrónico' },
        { key: 'phoneNumber', label: 'Número de teléfono' },
        { key: 'address.state', label: 'Estado' },
        { key: 'address.city', label: 'Municipio' },
        { key: 'active', label: 'Estatus' },
        { key: 'preferential', label: 'Preferente' },
        // { key: 'tripsAvailable', label: 'Viajes Disponibles' },
        { key: 'acciones', label: 'Acciones' },
        { key: 'motivos', label: 'Motivos de Baja' },
      ],
      fieldsMotivos: [
        { key: 'reason', label: 'Razón', sortable: true, sortDirection: 'desc' },
        { key: 'concesionario.name', label: 'Concesionario' },
        { key: 'createdBy', label: 'Deshabilitado Por:' },
        { key: 'acciones', label: 'Acciones' },
      ],
      statusDictionary: {
        0: { label: '', class: 'text-black font-weight-bold' },
        1: { label: '✔', class: 'text-success font-weight-bold' },
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      id: 0,
      imageLoadData: '',
      idDelete: null,
      concesionarioId: null,
      getBansByConcesionarioId: [],
      totalRowsMotivos: 1,
      currentPageMotivos: 1,
      perPageMotivos: 10,
    }
  },
  apollo: {
    getBansByConcesionarioId: {
      query: gql`query getBansByConcesionarioId ($concesionarioId:Int) {
        getBansByConcesionarioId(concesionarioId: $concesionarioId) {
          id
          reason
          fileUrl
          concesionario{
            id
            name
          }
          createdBy
         }
      }`,
      context: headers(),
      error (erro) {
        console.log(erro)
      },
      variables() {
        return {
          concesionarioId: this.concesionarioId ? parseInt(this.concesionarioId) : 1,
        }
      },
      skip() {
        return this.skipQuery
      },
      result({ data }) {
        if (data.getBansByConcesionarioId) {
          this.totalRowsMotivos = data.getBansByConcesionarioId.length
        }
      },
    },
    getConcesionarios: {
      query: gql`query getConcesionarios{
      getConcesionarios{
        id
        name
        email
        phoneNumber
        rfc
        address{
          id
          city
          extNumber
          intNumber
          postalCode
          state
          suburb
          street
        }
        tripsAvailable
        active
        tripsAvailable
        preferential
      }
     }`,
      context: headers(),
      error (erro) {
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        console.log('this.$store.state.user ==>', this.$store.state.user)
        if (data.getConcesionarios) {
          this.totalRows = data.getConcesionarios.length
        }
      },
    },
  },
  methods: {
    viewEvidence(id) {
      window.open(id.id, 'blank')
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.reasonState = valid
      this.fileState = valid
      return valid
    },
    resetModal() {
      this.reason = ''
      this.reasonState = null
      this.selectedFile = null
      this.fileState = null
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    getIdRow(id) {
      this.idDelete = id.id
    },
    getIdMotivo(id) {
      this.concesionarioId = id.id
      this.$apollo.queries.getBansByConcesionarioId.skip = false
      this.$apollo.queries.getBansByConcesionarioId.refetch()
    },
    onFileSelected(event) {
      this.fileUploaded = event.target.files[0]
      this.fileExtension = this.fileUploaded.name.split('.').pop()
    },
    // Deshabilitación del concesionario
    async handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      this.objectFile.fileExtension = this.fileExtension
      this.objectFile.fileUploaded = this.fileUploaded
      const data = await uploadFileS3(this.objectFile)
      this.imageLoadData = data.Location
      /*
      .then(data => {
        this.imageLoadData = data.Location
      })
      .catch(err => {
        console.log(err)
      })
      */
      await this.$apollo.mutate({
        mutation: gql`mutation createConcesionarioBan($concesionarioId:Int, $fileUrl:String, $reason:String, $createdBy:String){
          createConcesionarioBan(concesionarioCancel:{
            concesionarioId: $concesionarioId
            fileUrl: $fileUrl
            reason: $reason
            createdBy: $createdBy
          }){
            id
          }
        }`,
        context: headers(),
        variables: {
          concesionarioId: this.idDelete,
          fileUrl: this.imageLoadData,
          reason: this.reason,
          createdBy: this.$store.state.user.email,
        },
      })
        .then(res => {
          this.delConcesionario()
        })
        .catch(err => {
          console.log(err)
        })

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing')
      })
    },
    validateCheckIn(concesionario) {
      this.enableDisableFranchiseName = concesionario.name
      // console.log(concesionario)
      this.$apollo.query({ query: GET_ACTIVE_CHECKIN_BY_CONCESIONARIOID, context: headers(), variables: { concesionarioId: parseInt(concesionario.id) } })
        .then(({ data }) => {
          // console.log(data)
          // console.log(concesionario)
          if (data.getActiveTaxiCheckInByConcesionarioId.length === 0) {
            // this.enableDisableFranchiseName = concesionario.name
            this.getIdRow({ id: concesionario.id })
          } else {
            this.showConfirm()
          }
        })
        .catch(error => {
          this.getIdRow({ id: concesionario.id })
          console.log(error)
        })
    },
    showConfirmDisable(concesionario) {
      Modal.confirm({
        title: 'Confirmar',
        content: `Deshabilitar al concesionario ${concesionario.email} ?`,
        okText: 'Aceptar',
        okType: 'Cancelar',
        cancelText: 'No',
        onOk: () => {
          this.validateCheckIn(concesionario)
        },
        onCancel() {
        },
      })
    },
    showConfirmEnable(concesionario) {
      Modal.confirm({
        title: 'Confirmar',
        content: `¿Estás seguro(a) que deseas habilitar el concesionario ${concesionario.name} ?`,
        okText: 'Aceptar',
        okType: 'Cancelar',
        cancelText: 'Cancelar',
        onOk: () => {
          this.activateFranchise({ id: concesionario.id })
        },
        onCancel() {
        },
      })
    },
    showConfirm() {
      Modal.info({
        title: 'Este concesionario no puede ser deshabilitado debido a que tiene concesiones asignadas y estas concesiones están vinculadas a un vehículo con un checkin activo',
        okText: 'Aceptar',
        cancelText: 'No',
        onOk() {},
      })
    },
    async delConcesionario() {
      await this.$apollo.mutate({
        mutation: gql`mutation deleteConcesionario($idDelete: Int) {
         deleteConcesionario(id:$idDelete){
          id
          name
        }
        }`,
        context: headers(),
        variables: {
          idDelete: parseInt(this.idDelete),
        },
      })
        .then(res => {
          this.$apollo.queries.getConcesionarios.refetch()
          // this.getConcesionarios = this.getConcesionarios.filter(item => item.id !== parseInt(this.idDelete))
        })
        .catch(error => {
          this.error = error.message
          console.log(error)
        })
    },
    // Habilitación del concesionario
    async activateFranchise(id) {
      await this.$apollo.mutate({
        mutation: gql`mutation activateConcesionario($idActivate: Int) {
          activateConcesionario(id:$idActivate){
            message
          }
        }`,
        context: headers(),
        variables: {
          idActivate: parseInt(id.id),
        },
      })
        .then(res => {
          this.$apollo.queries.getConcesionarios.refetch()
        })
        .catch(error => {
          this.error = error.message
          console.log(error)
        })
    },
  },
}
</script>
<style scoped>
</style>
